import type { FunctionComponent } from "react";
import { Garage, Organization, Service } from "@App/types";
import { ServiceIsGlass } from "@App/utils/conditionals/services";
import { useTranslation } from "react-i18next";
import { CheckIcon } from "@App/Components/common/Icons";
import {
  OrganizationIsArval,
  OrganizationIsMobilityConcept,
} from "@App/utils/conditionals/organization";

type AdditionalBookingInformationProps = {
  garage: Garage;
  organization: Organization;
  service: Service;
};

export const AdditionalBookingInformation: FunctionComponent<AdditionalBookingInformationProps> = (
  props: AdditionalBookingInformationProps,
) => {
  const { t } = useTranslation(); // i18next

  return (
    <div className="mt-2 md:grid md:grid-cols-2">
      {t("booking.moreInformation.bullet-point-1") && (
        <div className="flex text-left mb-2 md:mx-2">
          <CheckIcon primary className="shrink-0 mt-1" />
          <div className="ml-2">
            {!OrganizationIsArval(props.organization)
              ? t("booking.moreInformation.bullet-point-1", {
                  garageType: props.garage?.garageType?.display_name_singular,
                })
              : props.garage.liveBookable
                ? t("booking.moreInformation.instant-booking")
                : t("booking.moreInformation.request-booking")}
          </div>
        </div>
      )}
      {t("booking.moreInformation.bullet-point-2") && (
        <div className="flex text-left mb-2 md:mx-2">
          <CheckIcon primary className="shrink-0 mt-1" />
          <div className="ml-2">
            {t("booking.moreInformation.bullet-point-2", {
              garageType: props.garage?.garageType?.display_name_singular,
            })}
          </div>
        </div>
      )}
      {!OrganizationIsMobilityConcept(props.organization) &&
        t("booking.moreInformation.bullet-point-3") && (
          <div className="flex text-left mb-2 md:mx-2">
            <CheckIcon primary className="shrink-0 mt-1" />
            <div className="ml-2">
              {t("booking.moreInformation.bullet-point-3", {
                garageType: props.garage?.garageType?.display_name_singular,
              })}
            </div>
          </div>
        )}
      {t("booking.moreInformation.bullet-point-4") && (
        <div className="flex text-left mb-2 md:mx-2">
          <CheckIcon primary className="shrink-0 mt-1" />
          <div className="ml-2">
            {t("booking.moreInformation.bullet-point-4", {
              garageType: props.garage?.garageType?.display_name_singular,
            })}
          </div>
        </div>
      )}
      {t("booking.moreInformation.bullet-point-5") && (
        <div className="flex text-left mb-2 md:mx-2">
          <CheckIcon primary className="shrink-0 mt-1" />
          <div className="ml-2">
            {t("booking.moreInformation.bullet-point-5", {
              garageType: props.garage?.garageType?.display_name_singular,
            })}
          </div>
        </div>
      )}
      {ServiceIsGlass(props.service) && t("booking.moreInformation.bullet-point-6") && (
        <div className="flex text-left mb-2 md:mx-2">
          <CheckIcon primary className="shrink-0 mt-1" />
          <div className="ml-2">{t("booking.moreInformation.bullet-point-6")}</div>
        </div>
      )}
    </div>
  );
};
